import { BoxProps, SelectChangeEvent } from '@mui/material';
import { setCurrentConversionUnit } from 'Context/contexts/cacheData/CommonData';
import { useCacheDataController } from 'Context/contexts/CacheDataContext';
import CustomDropdown from '.';

type ConversionUnitDropdownProps = {
	handleChange?: (value: string) => void;
	boxProps?: BoxProps;
	dropdownIcon?: React.ElementType;
	selectedTextColor?: string;
	textColor?: string;
	iconColor?: string;
	bgColor?: string;
	borderColor?: string;
	hoverBgColor?: string;
	hoverTextColor?: string;
	selectedBgColor?: string;
	prefixLabel?: string;
};

const ConversionUnitDropdown = ({
	handleChange,
	boxProps,
	dropdownIcon,
	selectedTextColor,
	textColor,
	iconColor,
	bgColor,
	borderColor,
	hoverBgColor,
	hoverTextColor,
	selectedBgColor,
	prefixLabel
}: ConversionUnitDropdownProps) => {
	const [controller, dispatch] = useCacheDataController();
	const { conversionUnit } = controller;

	const handleByteChange = (event: SelectChangeEvent<string>) => {
		const value = event.target.value;
		setCurrentConversionUnit(dispatch, value);
		handleChange?.(value);
	};

	const prefix = prefixLabel ?? '';

	return (
		<CustomDropdown
			value={conversionUnit}
			handleChange={handleByteChange}
			options={[
				{ value: 'PB', label: `${prefix}PB` },
				{ value: 'TB', label: `${prefix}TB` },
				{ value: 'GB', label: `${prefix}GB` }
			]}
			boxProps={boxProps}
			dropdownIcon={dropdownIcon}
			selectedTextColor={selectedTextColor}
			textColor={textColor}
			iconColor={iconColor}
			bgColor={bgColor}
			borderColor={borderColor}
			hoverBgColor={hoverBgColor}
			hoverTextColor={hoverTextColor}
			selectedBgColor={selectedBgColor}
		/>
	);
};

export default ConversionUnitDropdown;
